// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/images/landing/smartphone-small.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/images/landing/fundo_lp.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.landing {
  font: 1em/1 vigaregular;
  overflow: hidden;
  background-color: #ab2429;
}
.landing .container {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 2rem;
}
.landing .button a {
  font: 1.5em/1 vigaregular;
  line-height: 24px;
  display: inline-block;
  padding: 14px 19px;
  text-align: center;
  text-decoration: none;
  color: #caa36c;
  border-radius: 5px;
  background-color: #fff;
}
.landing .button a.brown {
  color: #fff;
  background-color: #caa36c;
}
.landing header {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), transparent);
}
.landing header .container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 2em;
  padding-bottom: 1em;
}
.landing header .logo-container .logo {
  width: 100%;
  max-width: 110px;
}
.landing .hero {
  display: flex;
  width: 100%;
  min-height: 60vh;
}
.landing .hero .container {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  background-size: 0%;
  background-repeat: no-repeat;
}
@media only screen and (max-width: 767px) {
  .landing .hero .container {
    display: block;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 110% center;
    background-size: 40% auto;
  }
}
.landing .hero .circle {
  position: absolute;
  top: -100%;
  left: -50%;
  overflow: hidden;
  width: 200%;
  height: 200%;
  border-radius: 60%;
}
@media only screen and (max-width: 767px) {
  .landing .hero .circle {
    top: -110%;
    border-radius: 50%;
    width: 300%;
    left: -100%;
  }
}
.landing .hero .circle .hero-image {
  width: 100%;
  height: 100%;
  background-color: #92181e;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.landing .hero .heading {
  max-width: 600px;
  padding: 15em 0 10em 0;
}
@media only screen and (max-width: 767px) {
  .landing .hero .heading {
    max-width: 100%;
    padding: 15em 40% 10em 0;
  }
}
.landing .hero .heading h1 {
  font-size: 42px;
  margin-top: 5px;
  margin-bottom: 15px;
  color: white;
}
.landing .hero .heading h1 span:not(:last-child) {
  display: block;
  margin-bottom: 0.26em;
}
@media only screen and (max-width: 1024px) {
  .landing .hero .heading h1 {
    font-size: 36px;
  }
}
@media only screen and (max-width: 767px) {
  .landing .hero .heading h1 {
    font-size: 21px;
  }
}
.landing .hero .smartphones {
  top: 20%;
  max-width: 50%;
}
@media only screen and (max-width: 767px) {
  .landing .hero .smartphones {
    top: 7%;
  }
}
.landing .hero .smartphones img {
  width: 100%;
}
@media only screen and (max-width: 767px) {
  .landing .hero .smartphones {
    display: none;
  }
}
.landing .details {
  margin-bottom: 3em;
}
.landing .details .container {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  justify-content: space-between;
  margin: 10% auto;
}
@media only screen and (max-width: 767px) {
  .landing .details .container {
    display: block;
    margin: 0 0 10% 0;
  }
}
.landing .details .container .qr-code {
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-left: 6%;
}
@media only screen and (max-width: 1024px) {
  .landing .details .container .qr-code {
    max-width: 50%;
    margin-left: 5%;
  }
}
@media only screen and (max-width: 767px) {
  .landing .details .container .qr-code {
    margin: 0 auto;
    max-width: 100%;
  }
}
.landing .details .container .qr-code img {
  width: 50%;
  margin-right: 5%;
}
.landing .details .container .qr-code .qr-code__description {
  font: 2.4em/1 vigaregular;
  width: 50%;
  transition: all 0.4s;
  color: white;
}
@media only screen and (max-width: 1024px) {
  .landing .details .container .qr-code .qr-code__description {
    font: 1.6em/1 vigaregular;
  }
}
@media only screen and (max-width: 767px) {
  .landing .details .container .qr-code .qr-code__description {
    font: 1.4em/1 vigaregular;
  }
}
.landing .details .container .advantages {
  display: flex;
  align-items: center;
  flex-direction: column;
  height: auto;
  border: 2px solid #c8a169;
  border-radius: 5px;
  flex-shrink: 0;
  width: 100%;
  max-width: 400px;
}
@media only screen and (max-width: 1024px) {
  .landing .details .container .advantages {
    flex-shrink: 1;
  }
}
@media only screen and (max-width: 767px) {
  .landing .details .container .advantages {
    margin: 10% auto;
  }
}
.landing .details .container .advantages .advantages__title {
  font: 2em/1 vigaregular;
  position: absolute;
  display: block;
  margin-top: -0.5em;
  padding-right: 30px;
  padding-left: 30px;
  text-align: center;
  color: c8a169;
  color: #c8a169;
  background-color: #ab2429;
}
@media only screen and (min-width: 767px) {
  .landing .details .container .advantages .advantages__title {
    font: 2.5em/1 vigaregular;
  }
}
.landing .details .container .advantages .advantages__items {
  font: 1.6em/1 vigaregular;
  margin: 38px 20px;
  color: white;
}
@media only screen and (min-width: 767px) {
  .landing .details .container .advantages .advantages__items {
    font: 2em/1 vigaregular;
    margin: 38px 20px;
    color: white;
  }
}
.landing .details .container .advantages .advantages__items ul {
  padding: 0;
  list-style-type: none;
}
.landing .details .container .advantages .advantages__items ul li {
  line-height: 16px;
  display: flex;
  align-items: center;
}
@media only screen and (min-width: 767px) {
  .landing .details .container .advantages .advantages__items ul li {
    line-height: 26px;
  }
}
.landing .details .container .advantages .advantages__items ul li img {
  max-width: 30px;
  height: auto;
  margin-right: 10px;
}
.landing .details .container .advantages .advantages__items ul li:not(:last-child) {
  margin-bottom: 1em;
}
.landing footer {
  padding: 0;
}
.landing footer .links {
  padding-top: 1.5em;
  padding-bottom: 1.5em;
  /* min-height: 160px; */
  color: #c8a169;
  background-color: #232020;
}
.landing footer .links .container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
@media only screen and (max-width: 767px) {
  .landing footer .links .container {
    flex-direction: column;
    text-align: center;
  }
}
.landing footer .links .links__logo img {
  width: 100%;
}
.landing footer .links .links__items {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-left: 25%;
}
@media only screen and (max-width: 767px) {
  .landing footer .links .links__items {
    display: block;
    width: auto;
    margin: 0 2%;
  }
}
.landing footer .links .links__items a {
  font: 1.6em/1 vigaregular;
  display: block;
  margin: 5px 0;
  text-decoration: none;
  color: #c8a169;
}
.landing footer .copyrights {
  padding-top: 1em;
  padding-bottom: 1em;
  text-transform: uppercase;
  color: white;
  background-color: #caa36d;
}
.landing footer .copyrights .container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
@media only screen and (max-width: 767px) {
  .landing footer .copyrights .container {
    flex-direction: column;
    text-align: center;
  }
}
.landing footer .copyrights .container p {
  font: 1.6em/1 vigaregular;
}
.landing footer .copyrights .container p:nth-child(3) a {
  text-decoration: none;
  color: white;
}
@media only screen and (max-width: 767px) {
  .landing footer .copyrights .container p:not(:last-child) {
    margin-bottom: 0.5em;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/LandingPage.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;EACA,gBAAA;EACA,yBAAA;AACJ;AACI;EACI,WAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AACR;AAEI;EACI,yBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;AAAR;AACQ;EACI,WAAA;EACA,yBAAA;AACZ;AAGI;EACI,kBAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,6EAAA;AADR;AAEQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,mBAAA;AAAZ;AAIY;EACI,WAAA;EACA,gBAAA;AAFhB;AAOI;EACI,aAAA;EACA,WAAA;EACA,gBAAA;AALR;AAOQ;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,4BAAA;AALZ;AAMY;EAPJ;IAQQ,cAAA;IACA,yEAAA;IACA,yBAAA;EAHd;AACF;AAMQ;EACI,kBAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAJZ;AAKY;EARJ;IASQ,UAAA;IACA,kBAAA;IACA,WAAA;IACA,WAAA;EAFd;AACF;AAGY;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yDAAA;EACA,4BAAA;EACA,2BAAA;EACA,sBAAA;AADhB;AAKQ;EACI,gBAAA;EACA,sBAAA;AAHZ;AAIY;EAHJ;IAIQ,eAAA;IACA,wBAAA;EADd;AACF;AAGY;EACI,eAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;AADhB;AAEgB;EACI,cAAA;EACA,qBAAA;AAApB;AAEgB;EATJ;IAUQ,eAAA;EAClB;AACF;AAAgB;EAZJ;IAaQ,eAAA;EAGlB;AACF;AACQ;EACI,QAAA;EACA,cAAA;AACZ;AAAY;EAHJ;IAIQ,OAAA;EAGd;AACF;AAFY;EACI,WAAA;AAIhB;AADY;EAVJ;IAWQ,aAAA;EAId;AACF;AAAI;EACI,kBAAA;AAER;AACI;EACI,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,8BAAA;EACA,gBAAA;AACR;AAAQ;EANJ;IAOQ,cAAA;IACA,iBAAA;EAGV;AACF;AADQ;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AAGZ;AAFY;EALJ;IAMQ,cAAA;IACA,eAAA;EAKd;AACF;AAJY;EATJ;IAUQ,cAAA;IACA,eAAA;EAOd;AACF;AANY;EACI,UAAA;EACA,gBAAA;AAQhB;AALY;EACI,yBAAA;EACA,UAAA;EACA,oBAAA;EACA,YAAA;AAOhB;AANgB;EALJ;IAMQ,yBAAA;EASlB;AACF;AARgB;EARJ;IASQ,yBAAA;EAWlB;AACF;AAPQ;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;AASZ;AARY;EAVJ;IAWQ,cAAA;EAWd;AACF;AAVY;EAbJ;IAcQ,gBAAA;EAad;AACF;AAZY;EACI,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,yBAAA;AAchB;AAbgB;EAXJ;IAYQ,yBAAA;EAgBlB;AACF;AAbY;EACI,yBAAA;EACA,iBAAA;EACA,YAAA;AAehB;AAdgB;EAJJ;IAKQ,uBAAA;IACA,iBAAA;IACA,YAAA;EAiBlB;AACF;AAhBgB;EACI,UAAA;EACA,qBAAA;AAkBpB;AAjBoB;EACI,iBAAA;EACA,aAAA;EACA,mBAAA;AAmBxB;AAlBwB;EAJJ;IAKQ,iBAAA;EAqB1B;AACF;AApBwB;EACI,eAAA;EACA,YAAA;EACA,kBAAA;AAsB5B;AAlBoB;EACI,kBAAA;AAoBxB;AAbI;EACI,UAAA;AAeR;AAbQ;EACI,kBAAA;EACA,qBAAA;EAEA,uBAAA;EAEA,cAAA;EACA,yBAAA;AAaZ;AAZY;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AAchB;AAbgB;EAJJ;IAKQ,sBAAA;IACA,kBAAA;EAgBlB;AACF;AAZgB;EACI,WAAA;AAcpB;AAXY;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,gBAAA;AAahB;AAZgB;EANJ;IAOQ,cAAA;IACA,WAAA;IACA,YAAA;EAelB;AACF;AAdgB;EACI,yBAAA;EACA,cAAA;EACA,aAAA;EACA,qBAAA;EACA,cAAA;AAgBpB;AAZQ;EACI,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,yBAAA;AAcZ;AAbY;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AAehB;AAbgB;EALJ;IAMQ,sBAAA;IACA,kBAAA;EAgBlB;AACF;AAdgB;EACI,yBAAA;AAgBpB;AAbgB;EACI,qBAAA;EACA,YAAA;AAepB;AAZgB;EACI;IACI,oBAAA;EActB;AACF","sourcesContent":[".landing {\n    font: 1em/1 vigaregular;\n    overflow: hidden;\n    background-color: #ab2429;\n\n    .container {\n        width: 100%;\n        max-width: 1000px;\n        margin: 0 auto;\n        padding: 0 2rem;\n    }\n\n    .button a {\n        font: 1.5em/1 vigaregular;\n        line-height: 24px;\n        display: inline-block;\n        padding: 14px 19px;\n        text-align: center;\n        text-decoration: none;\n        color: #caa36c;\n        border-radius: 5px;\n        background-color: #fff;\n        &.brown {\n            color: #fff;\n            background-color: #caa36c;\n        }\n    }\n\n    header {\n        position: absolute;\n        z-index: 1;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: auto;\n        background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), transparent);\n        .container {\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            padding-top: 2em;\n            padding-bottom: 1em;\n        }\n\n        .logo-container {\n            .logo {\n                width: 100%;\n                max-width: 110px;\n            }\n        }\n    }\n\n    .hero {\n        display: flex;\n        width: 100%;\n        min-height: 60vh;\n\n        .container {\n            display: flex;\n            align-items: center;\n            flex-direction: row;\n            justify-content: space-between;\n            background-size: 0%;\n            background-repeat: no-repeat;\n            @media only screen and (max-width: 767px) {\n                display: block;\n                background: url(../../public/images/landing/smartphone-small.png) no-repeat 110% center;\n                background-size: 40% auto;\n            }\n        }\n\n        .circle {\n            position: absolute;\n            top: -100%;\n            left: -50%;\n            overflow: hidden;\n            width: 200%;\n            height: 200%;\n            border-radius: 60%;\n            @media only screen and (max-width: 767px) {\n                top: -110%;\n                border-radius: 50%;\n                width: 300%;\n                left: -100%;\n            }\n            .hero-image {\n                width: 100%;\n                height: 100%;\n                background-color: #92181e;\n                background-image: url(../../public/images/landing/fundo_lp.jpg);\n                background-repeat: no-repeat;\n                background-position: center;\n                background-size: cover;\n            }\n        }\n\n        .heading {\n            max-width: 600px;\n            padding: 15em 0 10em 0;\n            @media only screen and (max-width: 767px) {\n                max-width: 100%;\n                padding: 15em 40% 10em 0;\n            }\n\n            h1 {\n                font-size: 42px;\n                margin-top: 5px;\n                margin-bottom: 15px;\n                color: white;\n                span:not(:last-child) {\n                    display: block;\n                    margin-bottom: 0.26em;\n                }\n                @media only screen and (max-width: 1024px) {\n                    font-size: 36px;\n                }\n                @media only screen and (max-width: 767px) {\n                    font-size: 21px;\n                }\n            }\n        }\n\n        .smartphones {\n            top: 20%;\n            max-width: 50%;\n            @media only screen and (max-width: 767px) {\n                top: 7%;\n            }\n            img {\n                width: 100%;\n            }\n\n            @media only screen and (max-width: 767px) {\n                display: none;\n            }\n        }\n    }\n\n    .details {\n        margin-bottom: 3em;\n    }\n\n    .details .container {\n        display: flex;\n        align-items: center;\n        flex-direction: row-reverse;\n        justify-content: space-between;\n        margin: 10% auto;\n        @media only screen and (max-width: 767px) {\n            display: block;\n            margin: 0 0 10% 0;\n        }\n\n        .qr-code {\n            display: flex;\n            align-items: center;\n            flex-direction: row;\n            margin-left: 6%;\n            @media only screen and (max-width: 1024px) {\n                max-width: 50%;\n                margin-left: 5%;\n            }\n            @media only screen and (max-width: 767px) {\n                margin: 0 auto;\n                max-width: 100%;\n            }\n            img {\n                width: 50%;\n                margin-right: 5%;\n            }\n\n            .qr-code__description {\n                font: 2.4em/1 vigaregular;\n                width: 50%;\n                transition: all 0.4s;\n                color: white;\n                @media only screen and (max-width: 1024px) {\n                    font: 1.6em/1 vigaregular;\n                }\n                @media only screen and (max-width: 767px) {\n                    font: 1.4em/1 vigaregular;\n                }\n            }\n        }\n\n        .advantages {\n            display: flex;\n            align-items: center;\n            flex-direction: column;\n            height: auto;\n            border: 2px solid #c8a169;\n            border-radius: 5px;\n            flex-shrink: 0;\n            width: 100%;\n            max-width: 400px;\n            @media only screen and (max-width: 1024px) {\n                flex-shrink: 1;\n            }\n            @media only screen and (max-width: 767px) {\n                margin: 10% auto;\n            }\n            .advantages__title {\n                font: 2em/1 vigaregular;\n                position: absolute;\n                display: block;\n                margin-top: -0.5em;\n                padding-right: 30px;\n                padding-left: 30px;\n                text-align: center;\n                color: c8a169;\n                color: #c8a169;\n                background-color: #ab2429;\n                @media only screen and (min-width: 767px) {\n                    font: 2.5em/1 vigaregular;\n                }\n            }\n\n            .advantages__items {\n                font: 1.6em/1 vigaregular;\n                margin: 38px 20px;\n                color: white;\n                @media only screen and (min-width: 767px) {\n                    font: 2em/1 vigaregular;\n                    margin: 38px 20px;\n                    color: white;\n                }\n                ul {\n                    padding: 0;\n                    list-style-type: none;\n                    li {\n                        line-height: 16px;\n                        display: flex;\n                        align-items: center;\n                        @media only screen and (min-width: 767px) {\n                            line-height: 26px;\n                        }\n                        img {\n                            max-width: 30px;\n                            height: auto;\n                            margin-right: 10px;\n                        }\n                    }\n\n                    li:not(:last-child) {\n                        margin-bottom: 1em;\n                    }\n                }\n            }\n        }\n    }\n\n    footer {\n        padding: 0;\n\n        .links {\n            padding-top: 1.5em;\n            padding-bottom: 1.5em;\n\n            /* min-height: 160px; */\n\n            color: #c8a169;\n            background-color: #232020;\n            .container {\n                display: flex;\n                align-items: center;\n                justify-content: space-between;\n                @media only screen and (max-width: 767px) {\n                    flex-direction: column;\n                    text-align: center;\n                }\n            }\n\n            .links__logo {\n                img {\n                    width: 100%;\n                }\n            }\n            .links__items {\n                display: flex;\n                align-items: center;\n                justify-content: space-between;\n                width: 100%;\n                margin-left: calc(100% / 4);\n                @media only screen and (max-width: 767px) {\n                    display: block;\n                    width: auto;\n                    margin: 0 2%;\n                }\n                a {\n                    font: 1.6em /1 vigaregular;\n                    display: block;\n                    margin: 5px 0;\n                    text-decoration: none;\n                    color: #c8a169;\n                }\n            }\n        }\n        .copyrights {\n            padding-top: 1em;\n            padding-bottom: 1em;\n            text-transform: uppercase;\n            color: white;\n            background-color: #caa36d;\n            .container {\n                display: flex;\n                align-items: center;\n                justify-content: space-between;\n\n                @media only screen and (max-width: 767px) {\n                    flex-direction: column;\n                    text-align: center;\n                }\n\n                p {\n                    font: 1.6em/1 vigaregular;\n                }\n\n                p:nth-child(3) a {\n                    text-decoration: none;\n                    color: white;\n                }\n\n                @media only screen and (max-width: 767px) {\n                    p:not(:last-child) {\n                        margin-bottom: 0.5em;\n                    }\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
